import dayjs from 'dayjs';

export class TrueTime {
  static now(): dayjs.Dayjs {
    return dayjs();
  }
}
